module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gYN2U"))).then(() => module.bundle.root('2KbAe'));